import React from 'react';

import * as Types from 'types';

import { columnSpanDefault } from './helpers';

type Props<T> = {
  title: string;
  more?: {
    title?: string;
    URL: string;
  };
  items: T[];
  renderItem: (item: T, index: number) => React.ReactElement;
};

const makeKey = (index: number, item: Types.Identifiable | number | undefined) =>
  `${index}-${typeof item === 'number' ? item : typeof item === 'undefined' ? '' : item.id}`;

export const Slate: <T extends Types.Identifiable | number | undefined>(
  props: Props<T>,
) => React.ReactElement<Props<T>> = ({ title, items, renderItem, more }) => {
  return (
    <div className='slate'>
      <h2 className='slate__title'>
        {title}
        {more ? (
          <a className='slate__title-link link-border' href={more.URL}>
            {more.title || 'More'}
          </a>
        ) : null}
      </h2>
      <div className='row nbm-1'>
        {items.map((item, index) => {
          return (
            <div
              className={`col-12 col-sm-6 col-md-4 col-lg-${columnSpanDefault(
                index,
                items.length,
              )} mb-1`}
              key={makeKey(index, item)}
            >
              {renderItem(item, index)}
            </div>
          );
        })}
      </div>
    </div>
  );
};
